var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCssIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3371 79.9029L10.7395 5.875H83.2605L76.6541 79.8912L46.9559 88.125L17.3371 79.9029Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81.8329L70.9994 75.1794L76.6452 11.9292H47V81.8329Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 38.7486H59.0144L59.8427 29.4514H47V20.3716H69.7656L69.5483 22.8068L67.3187 47.8284H47V38.7486V38.7486Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0559 62.3278L47.0148 62.3395L36.9039 59.6076L36.2576 52.3667H27.1426L28.4145 66.6224L47.0118 71.7865L47.0559 71.7748V62.3278V62.3278Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2417 47.4434L57.149 59.6017L47.0234 62.3335V71.7806L65.6354 66.6223L65.7735 65.0889L67.3509 47.4434H58.2417V47.4434Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0324 20.3716V29.4514H25.101L24.9189 27.4098L24.5047 22.8068L24.2874 20.3716H47.0324V20.3716ZM47.0001 38.7486V47.8284H37.0155L36.8334 45.7868L36.4222 41.1838L36.2048 38.7486H47.0001V38.7486Z",
    fill: "#EBEBEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssIcon);
export default __webpack_public_path__ + "static/media/css-icon.c5cb6f0621deea45e83fe9a277b16786.svg";
export { ForwardRef as ReactComponent };